import { render } from "./BaseSpinner.vue?vue&type=template&id=1726c4fa&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=1726c4fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1726c4fa"]])

export default __exports__